import { COIN_PESEWAS, JOURNEYS, shiftNet } from '@accra/shared';
import { activeRoute } from '../world/route';
import type { RunState } from '../game/RunState';
import { earnedUnlocks } from '../meta/garage';
import { settleShift as settleMissions } from '../meta/missions';
import type { Profile } from '../meta/profile';
import { bumpStreak, currentStreak } from '../meta/streak';

export interface SettledShift {
  profile: Profile;
  /** Missions finished this shift, reported to the server for their rewards. */
  completed: { id: string; level: number }[];
  /** Local estimate of the wallet (the server's answer replaces it). */
  rewardsPesewas: number;
}

/** Everything that changes in the profile when a shift ends: best score, wallet, missions, streak, unlocks. */
export function settleShift(profile: Profile, state: RunState, now: number, missionReward: (level: number) => number, carryFuel = true): SettledShift {
  const { stats } = state;
  const { board, completed } = settleMissions(profile.missions, stats);
  const journey = state.arrived ? JOURNEYS[activeRoute().id] : undefined;
  const rewardsPesewas = completed.reduce((sum, m) => sum + missionReward(m.level), 0) + (journey?.bonusPesewas ?? 0);
  const streak = bumpStreak(profile.streak, now);
  const unlocks = [...new Set([...profile.unlocks, ...earnedUnlocks(currentStreak(streak, now), now)])];
  return {
    completed,
    rewardsPesewas,
    profile: {
      ...profile,
      bestScore: Math.max(profile.bestScore, Math.floor(stats.score)),
      // Fines and repairs can push the wallet below zero: the driver owes it and pays it off from later fares.
      walletPesewas: profile.walletPesewas + shiftNet(stats.faresPesewas, stats.finesPesewas, stats.repairsPesewas, stats.fuelPesewas) + rewardsPesewas + stats.coins * COIN_PESEWAS,
      runs: profile.runs + 1,
      // The tank carries over to the next ordinary shift; challenges start full and leave your own tank alone.
      fuelUnits: carryFuel ? Math.round(state.fuel.units * 10) / 10 : profile.fuelUnits,
      missions: board,
      streak,
      unlocks,
    },
  };
}
